export default {
    name: "Hem",
    title: "Hem",
    description: "Köp dina pokaler och medaljer hos Lundgrens. Snabba leveranser av idrottspriser, lotter och bingo.",
    activitySlider: {
        header: "Välj sport"
    }
}